const swiper = new Swiper(".mainpage-slider", {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
    }
);